import { ORG_MEMBERS_PAGE_TYPE, ORG_INVITES_PAGE_TYPE, ORG_MIGRATIONS_PAGE_TYPE } from './constants'
import {
  paginationSelector as invitesPaginationSelector,
  sortOrderSelector as invitesSortOrderSelector,
  sortFieldSelector as invitesSortFieldSelector
} from './invitation_memberships/selectors'
import {
  slice as invitationMembershipsSlice,
  fetchInvitationMemberships
} from './invitation_memberships/slice'
import {
  paginationSelector as migrationsPaginationSelector,
  sortOrderSelector as migrationsSortOrderSelector,
  sortFieldSelector as migrationsSortFieldSelector
} from './migration_memberships/selectors'
import {
  slice as migrationMembershipsSlice,
  fetchMigrationMemberships
} from './migration_memberships/slice'
import {
  paginationSelector as orgMembersPaginationSelector,
  sortOrderSelector as orgMembersSortOrderSelector,
  sortFieldSelector as orgMembersSortFieldSelector
} from './user_memberships/selectors'
import {
  slice as orgMembershipsSlice,
  fetchUserMemberships
} from './user_memberships/slice'

export const determinePageSlice = (pageType) => {
  switch (pageType) {
    case ORG_MEMBERS_PAGE_TYPE:
      return orgMembershipsSlice
    case ORG_INVITES_PAGE_TYPE:
      return invitationMembershipsSlice
    case ORG_MIGRATIONS_PAGE_TYPE:
      return migrationMembershipsSlice
    default:
      throw new Error('Unhandled page type')
  }
}

export const fetchMethod = (pageType) => {
  switch (pageType) {
    case ORG_MEMBERS_PAGE_TYPE:
      return fetchUserMemberships
    case ORG_INVITES_PAGE_TYPE:
      return fetchInvitationMemberships
    case ORG_MIGRATIONS_PAGE_TYPE:
      return fetchMigrationMemberships
    default:
      throw new Error('Unhandled page type')
  }
}

export const determinePaginationData = (state, pageType) => {
  switch (pageType) {
    case ORG_MEMBERS_PAGE_TYPE:
      return orgMembersPaginationSelector(state)
    case ORG_INVITES_PAGE_TYPE:
      return invitesPaginationSelector(state)
    case ORG_MIGRATIONS_PAGE_TYPE:
      return migrationsPaginationSelector(state)
    default:
      throw new Error('Unhandled page type')
  }
}

export const determineSortingData = (state, pageType) => {
  switch (pageType) {
    case ORG_MEMBERS_PAGE_TYPE:
      return { sortOrder: orgMembersSortOrderSelector(state), sortField: orgMembersSortFieldSelector(state) }
    case ORG_INVITES_PAGE_TYPE:
      return { sortOrder: invitesSortOrderSelector(state), sortField: invitesSortFieldSelector(state) }
    case ORG_MIGRATIONS_PAGE_TYPE:
      return { sortOrder: migrationsSortOrderSelector(state), sortField: migrationsSortFieldSelector(state) }
    default:
      throw new Error('Unhandled page type')
  }
}

export const getMemberGroupRoles = (member, userGroup) => {
  const memberRolesForGroup = member.user_group_relationships[userGroup.id]

  return {
    isAdmin: memberRolesForGroup.admin !== undefined,
    isMember: memberRolesForGroup.member !== undefined
  }
}
